import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const modules = {}
const files = require.context('./modules', true, /\.js$/)

files.keys().forEach((path, i) => {
  const module = files(path)
  Object.keys(module).forEach(lang => {
    modules[lang] = module[lang]
  })
})

export default new Vuex.Store({
  modules
})



// WEBPACK FOOTER //
// ./src/store/index.js